import React from "react";
import "./Registration.scss";
import logo from "../../../assets/images/MainLogo.png";
import TextInput from "../../../components/TextInput/TextInput";
import Buttons from "../../../components/Buttons/Buttons";
import Spinner from "../../../components/Spinner/Spinner";
import PasswordRequirements from "../../../components/PasswordRequirements/PasswordRequirements";
import useRegistration, {
  UDI_STATIC_PREFIX,
  DEVICE_ID_PREFIX,
} from "./useRegistration";

const Registration = () => {
  const {
    formData,
    errors,
    isSubmitting,
    isVerifyingEmail,
    isEmailVerified,
    handleChange,
    handleVerifyEmail,
    handleSubmit,
    handleBackToSignIn,
  } = useRegistration();

  return (
    <div className="hpreg">
      {isSubmitting && (
        <div className="loader-container">
          <div className="loader">
            <Spinner />
          </div>
        </div>
      )}
      <div className="hpreg_bcg">
        <div className="hpreg_container">
          <div className="hpreg_section">
            <div className="hpreg_section_logo">
              <img src={logo} alt="logo" />
            </div>
            <div className="hpreg_section_header">
              <h3>WeBe Registration</h3>
              <p>Please enter your details below to create your account</p>
            </div>

            <div className="hpreg_section_inputs">
              <div className="hpreg_section_inputs_data hpreg_section_inputs_row">
                <TextInput
                  title="Name"
                  type="text"
                  name="name"
                  icon="user"
                  placeholder="Enter your name"
                  value={formData.name}
                  onChange={handleChange}
                  error={!!errors.name}
                  helperText={errors.name}
                />
                <TextInput
                  title="Username"
                  type="text"
                  name="username"
                  icon="user"
                  placeholder="Enter your username"
                  value={formData.username}
                  onChange={handleChange}
                  error={!!errors.username}
                  helperText={errors.username}
                />
              </div>

              <div className="hpreg_section_inputs_data">
                <TextInput
                  title="Email Address"
                  type="email"
                  name="email"
                  icon="mail"
                  placeholder="Enter your email address"
                  value={formData.email}
                  onChange={handleChange}
                  error={!!errors.email}
                  helperText={errors.email}
                  endAction={{
                    text: isVerifyingEmail
                      ? "Verifying…"
                      : isEmailVerified
                        ? "Verified"
                        : "Verify",
                    onClick: handleVerifyEmail,
                    disabled: isVerifyingEmail || isEmailVerified,
                    loading: isVerifyingEmail,
                    verified: isEmailVerified,
                  }}
                />
              </div>

              <div className="hpreg_section_inputs_data hpreg_section_inputs_udi">
                <span className="hpreg_section_inputs_udi_label">
                  Device UDI
                </span>
                <span className="hpreg_section_inputs_udi_static">
                  {UDI_STATIC_PREFIX}
                </span>
                <div className="hpreg_section_inputs_udi_row">
                  <TextInput
                    name="udiLotCode"
                    placeholder="e.g., 00A"
                    prefixText="(10)"
                    maxLength={3}
                    value={formData.udiLotCode}
                    onChange={handleChange}
                    error={!!errors.udiLotCode}
                    helperText={errors.udiLotCode}
                  />
                  <TextInput
                    name="udiSerial"
                    placeholder="e.g., 0000000"
                    prefixText="(21)"
                    maxLength={7}
                    value={formData.udiSerial}
                    onChange={handleChange}
                    error={!!errors.udiSerial}
                    helperText={errors.udiSerial}
                  />
                </div>
                <span className="hpreg_section_inputs_udi_hint">
                  Used to validate the identity of the user registering.
                </span>
              </div>

              <div className="hpreg_section_inputs_data">
                <TextInput
                  title="Device ID"
                  type="text"
                  name="deviceIdSuffix"
                  icon="watch"
                  prefixText={DEVICE_ID_PREFIX}
                  placeholder="72f9"
                  maxLength={4}
                  value={formData.deviceIdSuffix}
                  onChange={handleChange}
                  error={!!errors.deviceIdSuffix}
                  helperText={errors.deviceIdSuffix}
                />
              </div>

              <div className="hpreg_section_inputs_data">
                <TextInput
                  title="Password"
                  type="password"
                  name="password"
                  icon="lock"
                  placeholder="Enter your password"
                  value={formData.password}
                  onChange={handleChange}
                  error={!!errors.password}
                  helperText={errors.password}
                />
                <PasswordRequirements password={formData.password} />
              </div>

              <div className="hpreg_section_inputs_data">
                <TextInput
                  title="Confirm Password"
                  type="password"
                  name="confirmPassword"
                  icon="lock"
                  placeholder="Re-enter your password"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                  error={!!errors.confirmPassword}
                  helperText={errors.confirmPassword}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      handleSubmit();
                    }
                  }}
                />
              </div>
            </div>

            <div className="hpreg_section_buttons">
              <Buttons
                text="Create Account"
                variant="primary"
                onClick={handleSubmit}
                disabled={isSubmitting}
              />
            </div>
            <div className="hpreg_section_back">
              <button
                type="button"
                className="back-link"
                onClick={handleBackToSignIn}
              >
                Back to Sign In
              </button>
            </div>
          </div>
        </div>
        <div className="hpreg_bcglayout"></div>
      </div>
    </div>
  );
};

export default Registration;
